import React, { memo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { reduxBatch } from '@manaflair/redux-batch'
import { wallActions, roofActions, jobSettingsActions } from '../../../store/slices'
import { getRoofState, getWallState, getSettingsState } from '../../../store/slices/selectors'

import { Accordion, Button, ButtonGroup } from '../../../../../components'

import { defaultValues } from '../../../common/json/common.json'
import { applicationTypeOptions } from '../../../common/json/carried-member.json'
import { APPLICATION_TYPES } from '../../../common/constants'

const ApplicationTypeSelection = ({ country }) => {
  const dispatch = useDispatch()
  const applicationType = useSelector((state) => getWallState(state).applicationType)
  const roofMemberType = useSelector((state) => getRoofState(state).memberType)
  const isUSA = useSelector((state) => getSettingsState(state).isUSA)

  useEffect(() => {
    if (!isUSA && applicationType === APPLICATION_TYPES.CORNER_END_WALL)
      handleSelectApplicationType('applicationType', APPLICATION_TYPES.PERPENDICULAR_TO_WALL)
  }, [isUSA])

  const handleSelectApplicationType = (name, value) => {
    const updatedJobSettings = { ...defaultValues.jobSettings[value][country] }
    const updatedWall = {
      [name]: value,
      memberType: updatedJobSettings.wallMemberType,
      ...defaultValues.wall[updatedJobSettings.wallMemberType],
    }
    const updatedRoof =
      value === APPLICATION_TYPES.PARALLEL_TO_WALL
        ? { ...defaultValues.roof.truss.Parallel_To_Wall }
        : {
            ...(defaultValues.roof[roofMemberType][value] ??
              defaultValues.roof[roofMemberType].default),
          }

    reduxBatch([
      dispatch(jobSettingsActions.updateCalculation(updatedJobSettings)),
      dispatch(wallActions.updateCalculation(updatedWall)),
      dispatch(roofActions.updateCalculation(updatedRoof)),
    ])
  }

  return (
    <Accordion title="Application Type">
      <ButtonGroup
        className="row"
        name="applicationType"
        value={applicationType}
        onChange={handleSelectApplicationType}
      >
        {({ handleClick, value, getBtnClassName }) =>
          applicationTypeOptions.map((item) => {
            const checked = item.value === value
            return (
              <div className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3" key={item.value}>
                <Button
                  type="button"
                  variant="subAppSelector"
                  value={item.value}
                  className={getBtnClassName(checked)}
                  onClick={(e) => handleClick(e, item.value)}
                  disabled={item.value === APPLICATION_TYPES.CORNER_END_WALL && !isUSA}
                >
                  <img className="illustration" src={item.imgSrc} />
                  <div className="button__text">{item.text}</div>
                </Button>
              </div>
            )
          })
        }
      </ButtonGroup>
    </Accordion>
  )
}

ApplicationTypeSelection.propTypes = {
  country: PropTypes.string.isRequired,
}

export default memo(ApplicationTypeSelection)
